export enum SearchContactsAndOutletsTypeApiEnum {
    outlet = 'OUTLET',
    contact = 'CONTACT'
}
